import { Tabs, Modal, Flex, Space, Progress } from 'antd';
// import Feedbacks from 'pages/Feedbacks';
import Information from 'pages/Information';
import InformationCategories from 'pages/InformationCategories';
import MediaCategories from 'pages/MediaCategories';
import MediaLibrary from 'pages/MediaLibrary';
import Pois from 'pages/Pois';
import { log } from 'utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setActiveTab } from 'state/actions/tab';
import ScreenSettings from 'pages/ScreenSettings';
import ConfigVariable from 'pages/ConfigVariable';
import ScreenConfiguration from 'pages/ScreenConfiguration';
import FileManagement from 'pages/FileManagement';
import Screens from 'pages/Screens';
import Maps from 'pages/Maps';
import Events from 'pages/Events';
import Deals from 'pages/Deals';
// import SessionAnalyticsDashboard from 'pages/SessionAnalytics';
// import AnalyticIcon from 'assets/icon/dynamic/AnalyticIcon';
import { setBreadcrumb } from 'state/actions/breadcrumb';
import {
  BoxIcon,
  GalleryIcon,
  InfoIcon,
  MessageIcon,
} from 'assets/icon/dynamic';
import Analytics from 'pages/Analytics';
import MapViewer from 'pages/MapViewer';
import Configuration from 'pages/Configuration';
import './SiteInfo.css';
import MediaAnalytic from '../MediaAnalytic';
// import MediaAnalytic from 'pages/MediaAnalytic';
// import MediaAnalytic from 'pages/MediaAnalytic';

import { FormFlow } from '@adsign/form-management';

import { url } from 'utils/url';
import {
importerStart,
importerCancel
} from 'state/actions/importer';
import RoomManagementIcon from 'assets/icon/dynamic/RoomManagementIcon';
import BookingManagement from 'components/BookingManagement';
import { io } from 'socket.io-client';
import QuestionMark from '../../assets/questionmark.png';

const { TabPane } = Tabs;

function SiteInfo({ history, setCollapsed }) {
  const { siteId, siteName } = useParams();
  const [grantAccess, setGrantAccess] = useState();

  const dispatch = useDispatch();
  const {
    tab: activeTab,
    userData,
    sitesList,
  } = useSelector((state) => ({
    tab: state.tab.tab,
    userData: state.auth.userData,
    sitesList: state.sites.list,
  }));

  const [hoverTab, setHoverTab] = useState(activeTab);

  const site = sitesList?.find((siteData) => siteData._id === siteId);
  const isAdsum = site?.isAdsum;
  const [modalFetchData, setModalFetchData] = useState(false);
  const [modalFetchProgress, setModalFetchProgress] = useState(false);
  const [modalFetchProgressCancel, setModalFetchProgressCancel] =
    useState(false);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');
  const [importStarted, setImportStarted] = useState(false);
  const [step, setStep] = useState('');

  useEffect(() => {
    const acc =
      userData.role !== 'superadmin' && userData.roleAccess
        ? userData.roleAccess.access.find(
            (userAccess) => userAccess.siteId === siteId
          )
        : userData.access.find((userAccess) => userAccess.siteId === siteId) ??
          userData.access[0];
    setGrantAccess(acc ?? userData.access[0]);
  }, [siteId, userData]);

  useEffect(() => {
    dispatch(
      setBreadcrumb([
        { menu: siteName, link: `/${siteId}/information/${siteName}` },
      ])
    );

    // if(site.editorSiteId)dispatch(fetchEditorData({ siteId: site.editorSiteId }));
  }, [siteId]); // eslint-disable-line

  // useEffect(() => {
  //   console.log(selected, 'selected')
  //   if (selected) {
  //     dispatch(setActiveTab({ tab: selected }));
  //   }
  // }, [selected]); // eslint-disable-line

  const handleChangeTab = (activeKey) => {
    log(activeKey);
    // setActiveTab(activeKey);
    dispatch(setActiveTab({ tab: activeKey }));
  };

  const siteDescription =
    sitesList &&
    // eslint-disable-next-line
    sitesList.map((site) => {
      if (site.name === siteName) {
        return site.description;
      }
    });

  const validateMenu = (crud) => {
    if (typeof crud !== 'object') return crud;

    return Object.values(crud).includes(true);
  };

  useEffect(() => {
    if (!importStarted) return;

    const socket = io(`${url}`, { transports: ['websocket'] });
    const userId = userData.id;
    const token = localStorage.getItem('accessToken');

    const handleProgressUpdate = (data) => {
      setProgress(data.progress);
      setStatus(data.status);
      setStep(data.currentStep);

      if (data.status === 'completed' && data.progress === 100) {
        setModalFetchProgress(false);
        setProgress(0);
        setStatus('');
        setStep('');
        console.log('Import completed');
      } else if (data.status === 'error') {
        console.error('Import failed');
      }
    };

    socket.emit('subscribe_import_progress', { userId, token }, (response) => {
      if (response.error === 0) {
        console.log('Subscribed to import progress updates');
        dispatch(importerStart(siteId));
      } else {
        console.error('Subscription failed:', response.message);
      }
    });

    socket.on('import_progress_update', handleProgressUpdate);

    return () => {
      socket.off('import_progress_update', handleProgressUpdate);
      socket.disconnect();
      setImportStarted(false);
    };
  }, [importStarted, dispatch, userData.id]);

  const handleOpenFetchModal = () => {
    setModalFetchData(true);
  };

  const handleOpenFetchLoad = () => {
    setModalFetchData(false);
    setModalFetchProgress(true);
    setImportStarted(true);
  };
  const handleOpenFetchCancel = () => {
    setModalFetchProgress(false);
    setModalFetchProgressCancel(true);
  };
  const handleCloseFetchConfirm = () => {
    setModalFetchProgressCancel(false);
    dispatch(importerCancel());
    setModalFetchProgress(false);
    setProgress(0);
    setStatus('');
    setStep('');
  };
  const handleCloseFetchCancel = () => {
    setModalFetchProgress(true);
    setModalFetchProgressCancel(false);
  };

  const canImport = userData.role === 'superadmin' || (grantAccess && validateMenu(grantAccess.importer))

  return (
    <>
      <Modal
        footer={true}
        onCancel={() => {
          setModalFetchData(false);
        }}
        visible={modalFetchData}
        title="Fetch Data Confirmation"
        className="adsign-modal"
        closeIcon={<i className="feather-x" />}
      >
        <div className="modal-content-fetch">
          <svg
            width="220"
            height="160"
            viewBox="0 0 220 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="110"
              cy="80"
              r="80"
              fill="url(#paint0_linear_3997_42978)"
            />
            <circle cx="26" cy="20" r="8" fill="#F2F4F7" />
            <circle cx="198" cy="126" r="6" fill="#F2F4F7" />
            <circle cx="25" cy="138" r="10" fill="#F2F4F7" />
            <circle cx="210" cy="46" r="10" fill="#F2F4F7" />
            <circle cx="191" cy="11" r="7" fill="#F2F4F7" />
            <g filter="url(#filter0_dd_3997_42978)">
              <path
                d="M113.485 16C133.961 16 151.543 28.3802 159.161 46.0625C160.486 45.9093 161.834 45.8281 163.2 45.8281C182.42 45.8282 198 61.4095 198 80.6289C198 99.5478 182.903 114.94 164.099 115.417L163.2 115.429H63.7715L62.7451 115.416C41.2543 114.872 24 97.2792 24 75.6572C24 53.6921 41.8063 35.8857 63.7715 35.8857C66.9248 35.8857 69.992 36.2546 72.9336 36.9482C81.9428 24.2707 96.7484 16.0001 113.485 16Z"
                fill="#F9FAFB"
              />
              <circle
                cx="63.7714"
                cy="75.6581"
                r="39.7714"
                fill="url(#paint1_linear_3997_42978)"
              />
              <circle
                cx="113.486"
                cy="65.7143"
                r="49.7143"
                fill="url(#paint2_linear_3997_42978)"
              />
              <circle
                cx="163.2"
                cy="80.6281"
                r="34.8"
                fill="url(#paint3_linear_3997_42978)"
              />
            </g>
            <rect
              x="82"
              y="84"
              width="56"
              height="56"
              rx="28"
              fill="url(#paint4_linear_3997_42978)"
            />
            <g clip-path="url(#clip0_3997_42978)">
              <path
                d="M114.667 116.668L110 112.001M110 112.001L105.334 116.668M110 112.001V122.501M119.789 119.456C120.926 118.836 121.825 117.854 122.343 116.666C122.861 115.478 122.969 114.151 122.649 112.896C122.33 111.64 121.601 110.526 120.578 109.73C119.555 108.934 118.296 108.502 117 108.501H115.53C115.177 107.135 114.519 105.867 113.605 104.792C112.691 103.717 111.546 102.864 110.255 102.295C108.963 101.727 107.56 101.458 106.15 101.51C104.74 101.562 103.361 101.933 102.115 102.595C100.869 103.257 99.7894 104.193 98.9573 105.332C98.1251 106.471 97.562 107.784 97.3103 109.172C97.0587 110.561 97.125 111.988 97.5043 113.347C97.8836 114.705 98.566 115.961 99.5002 117.018"
                stroke="white"
                stroke-width="2.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <filter
                id="filter0_dd_3997_42978"
                x="4"
                y="16"
                width="214"
                height="139.43"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="4"
                  operator="erode"
                  in="SourceAlpha"
                  result="effect1_dropShadow_3997_42978"
                />
                <feOffset dy="8" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3997_42978"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="4"
                  operator="erode"
                  in="SourceAlpha"
                  result="effect2_dropShadow_3997_42978"
                />
                <feOffset dy="20" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
                />
                <feBlend
                  mode="normal"
                  in2="effect1_dropShadow_3997_42978"
                  result="effect2_dropShadow_3997_42978"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect2_dropShadow_3997_42978"
                  result="shape"
                />
              </filter>
              <linearGradient
                id="paint0_linear_3997_42978"
                x1="110"
                y1="0"
                x2="110"
                y2="160"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#E3F1FF" />
                <stop offset="1" stop-color="#D1E6FF" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_3997_42978"
                x1="33.2326"
                y1="49.3806"
                x2="103.543"
                y2="115.43"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#D0D5DD" />
                <stop offset="0.350715" stop-color="white" stop-opacity="0" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_3997_42978"
                x1="75.3123"
                y1="32.8673"
                x2="163.2"
                y2="115.428"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#D0D5DD" />
                <stop offset="0.350715" stop-color="white" stop-opacity="0" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_3997_42978"
                x1="136.478"
                y1="57.6353"
                x2="198"
                y2="115.428"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#D0D5DD" />
                <stop offset="0.350715" stop-color="white" stop-opacity="0" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_3997_42978"
                x1="116"
                y1="84"
                x2="110.873"
                y2="140.08"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFCF7B" />
                <stop offset="1" stop-color="#FF972F" />
              </linearGradient>
              <clipPath id="clip0_3997_42978">
                <rect
                  width="28"
                  height="28"
                  fill="white"
                  transform="translate(96 98)"
                />
              </clipPath>
            </defs>
          </svg>
          <p className="modal-content-title">Fetch Data</p>
          <p className="modal-content-description">
            Are you sure you want to fetch the latest data? This action will
            update the current content.
          </p>
        </div>
        <div className="modal-footer-fetch">
          <button className="button-cancel">Cancel</button>
          <button className="button-confirm" onClick={handleOpenFetchLoad}>
            Confirm
          </button>
        </div>
      </Modal>

      {/* modal progress fetch  */}
      <Modal
        closable={false}
        footer={true}
        onCancel={() => {
          setModalFetchProgress(false);
        }}
        visible={modalFetchProgress}
        title=""
        className="adsign-modal"
        closeIcon={''}
        keyboard={false}
        maskClosable={false}
      >
        <Space>
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="56"
              height="56"
              rx="28"
              fill="url(#paint0_linear_4000_43072)"
            />
            <g clip-path="url(#clip0_4000_43072)">
              <path
                d="M32.6669 32.6677L28.0002 28.001M28.0002 28.001L23.3335 32.6677M28.0002 28.001V38.501M37.7885 35.456C38.9264 34.8357 39.8253 33.8541 40.3434 32.6661C40.8614 31.4781 40.9691 30.1515 40.6494 28.8955C40.3298 27.6395 39.6009 26.5258 38.578 25.7301C37.555 24.9343 36.2962 24.5019 35.0002 24.501H33.5302C33.1771 23.1352 32.5189 21.8671 31.6051 20.7922C30.6914 19.7173 29.5459 18.8635 28.2546 18.2951C26.9634 17.7266 25.5602 17.4583 24.1503 17.5102C22.7405 17.5622 21.3608 17.9331 20.1149 18.595C18.869 19.2569 17.7894 20.1927 16.9573 21.3319C16.1251 22.4711 15.562 23.7842 15.3103 25.1723C15.0587 26.5605 15.125 27.9877 15.5043 29.3465C15.8836 30.7054 16.566 31.9605 17.5002 33.0177"
                stroke="white"
                stroke-width="2.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_4000_43072"
                x1="34"
                y1="-9.64842e-07"
                x2="28.8731"
                y2="56.0798"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#90BFFF" />
                <stop offset="1" stop-color="#2C82F6" />
              </linearGradient>
              <clipPath id="clip0_4000_43072">
                <rect
                  width="28"
                  height="28"
                  fill="white"
                  transform="translate(14 14)"
                />
              </clipPath>
            </defs>
          </svg>

          <Flex gap="" vertical>
            <p>{progress}% Data fetch in progress</p>
            <p>{status}</p>
            <Progress
              showInfo={false}
              percent={progress}
              size={{ width: 400 }}
            />
          </Flex>
        </Space>
        <div className="modal-content-delete">
          <p
            className="modal-content-description"
            style={{ marginTop: '2rem' }}
          >
            You can’t close this page while fetching is still running.
          </p>
        </div>

        <div
          className="modal-footer-fetch-cancel"
          style={{ marginTop: '2rem' }}
        >
          <button
            className="button-cancel-fetching"
            onClick={handleOpenFetchCancel}
          >
            Cancel Fetching
          </button>
        </div>

        {/* modal confirmation cancel fetch */}
      </Modal>

      <Modal
        closable={false}
        footer={true}
        onCancel={() => {
          setModalFetchProgressCancel(false);
        }}
        visible={modalFetchProgressCancel}
        title=""
        className="adsign-modal"
        closeIcon={''}
      >
        <div className="modal-content-fetch">
          <img src={QuestionMark} />
          <p className="modal-content-title" style={{ marginTop: '1rem' }}>
            Cancel Fetch Data
          </p>
          <p className="modal-content-description">
            Are you sure you want to cancel the data fetch? Any progress will be
            lost.
          </p>
        </div>
        <div className="modal-footer-fetch" style={{ marginTop: '2rem' }}>
          <button className="button-cancel" onClick={handleCloseFetchCancel}>
            Cancel
          </button>
          <button className="button-confirm" onClick={handleCloseFetchConfirm}>
            Confirm
          </button>
        </div>
      </Modal>
      <div className="siteinfo">
        <div className="siteinfo-nav p-20">
          <div>
            {siteName && siteName.length > 30 ? (
              <h3 className="title">{siteName.substr(0, 30)}</h3>
            ) : (
              <h3 className="title">{siteName}</h3>
            )}
            <span>{siteDescription && siteDescription}</span>
          </div>
          {canImport && 
            <button onClick={handleOpenFetchModal} className="button-primary">
              Fetch Data
            </button>
          }
        </div>

        {userData && userData.role === 'superadmin' ? (
          <Tabs activeKey={activeTab} onTabClick={handleChangeTab}>
            <TabPane
              onMouseOver={() => setHoverTab('media')}
              onMouseLeave={() => setHoverTab('')}
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                >
                  <GalleryIcon
                    color={
                      activeTab === 'media' || hoverTab === 'media'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Media</span>
                </div>
              }
              key={activeTab === 'mediaCategory' ? 'mediaCategory' : 'media'}
            >
              <div className="tab-content">
                {activeTab === 'media' && <MediaLibrary history={history} />}
                {activeTab === 'mediaCategory' && <MediaCategories />}
              </div>
            </TabPane>
            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('poi')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'poi' || hoverTab === 'poi'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Tenants</span>
                </div>
              }
              key="poi"
            >
              <div className="tab-content">
                {activeTab === 'poi' && <Pois history={history} />}
              </div>
            </TabPane>

            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('event')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'event' || hoverTab === 'event'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Events</span>
                </div>
              }
              key="event"
            >
              <div className="tab-content">
                {activeTab === 'event' && <Events history={history} />}
              </div>
            </TabPane>

            <TabPane
            tab={
              <div
                onClick={(e) => e.preventDefault()}
                className="siteinfo-tab"
                onMouseOver={() => setHoverTab('deal')}
                onMouseLeave={() => setHoverTab('')}
              >
                <BoxIcon
                  color={
                    activeTab === 'deal' || hoverTab === 'deal'
                      ? '#0851B5'
                      : '#9E9E9E'
                  }
                  size={18}
                />
                <span>Deals</span>
              </div>
            }
            key="deal"
          >
            <div className="tab-content">
              {activeTab === 'deal' && <Deals history={history} />}
            </div>
          </TabPane>

            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('bookingManagement')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <RoomManagementIcon
                    color={
                      activeTab === 'bookingManagement' ||
                      hoverTab === 'bookingManagement'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Booking Management</span>
                </div>
              }
              key="bookingManagement"
            >
              <BookingManagement history={history} />
            </TabPane>

            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('information')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <InfoIcon
                    color={
                      activeTab === 'information' || hoverTab === 'information'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Information</span>
                </div>
              }
              key={
                activeTab === 'informationCategory'
                  ? 'informationCategory'
                  : 'information'
              }
            >
              <div className="tab-content">
                {activeTab === 'information' && (
                  <Information history={history} />
                )}
                {activeTab === 'informationCategory' && (
                  <InformationCategories />
                )}
              </div>
            </TabPane>

            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('formMangement')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'formMangement' ||
                      hoverTab === 'formMangement'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Form Management</span>
                </div>
              }
              key="formManagement"
            >
              <div className="tab-content">
                {activeTab === 'formManagement' && (
                  <FormFlow
                    siteId={siteId}
                    url={url}
                    access={{
                      create: true,
                      read: true,
                      update: true,
                      delete: true,
                    }}
                  />
                )}
              </div>
            </TabPane>

            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('screen')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <MessageIcon
                    color={
                      activeTab === 'screen' || hoverTab === 'screen'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Screen</span>
                </div>
              }
              key={
                activeTab === 'screenConfiguration'
                  ? 'screenConfiguration'
                  : activeTab === 'configVariable'
                  ? 'configVariable'
                  : activeTab === 'screenSetting'
                  ? 'screenSetting'
                  : activeTab === 'fileManagement'
                  ? 'fileManagement'
                  : 'screens'
              }
            >
              <div className="tab-content">
                {activeTab === 'screens' && <Screens history={history} />}
                {activeTab === 'screenSetting' && (
                  <ScreenSettings handleChangeTab={handleChangeTab} />
                )}
                {activeTab === 'configVariable' && (
                  <ConfigVariable handleChangeTab={handleChangeTab} />
                )}
                {activeTab === 'screenConfiguration' && (
                  <ScreenConfiguration handleChangeTab={handleChangeTab} />
                )}
                {activeTab === 'fileManagement' && (
                  <FileManagement handleChangeTab={handleChangeTab} />
                )}
              </div>
            </TabPane>
            {isAdsum && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                  >
                    <i className="feather-globe" /> <span>Map Viewer</span>
                  </div>
                }
                key="map-viewer"
              >
                <div className="tab-content">
                  <MapViewer />
                </div>
              </TabPane>
            )}
            {/* <TabPane
            tab={
              <div
                onClick={(e) => e.preventDefault()}
                className="siteinfo-tab"
                onMouseOver={() => setHoverTab('sessionAnalytic')}
                onMouseLeave={() => setHoverTab('')}
              >
                <AnalyticIcon
                  color={
                    activeTab === 'sessionAnalytic' ||
                    hoverTab === 'sessionAnalytic'
                      ? '#0851B5'
                      : '#9E9E9E'
                  }
                  size={18}
                  stroke='#9E9E9E'
                />
                <span>Session Analytics</span>
              </div>
            }
            key="sessionAnalytic"
          >
            <div className="tab-content">
              {activeTab === 'sessionAnalytic' && (
                <SessionAnalyticsDashboard/>
              )}
            </div>
          </TabPane> */}
            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('mediaAnalytic')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'mediaAnalytic' ||
                      hoverTab === 'mediaAnalytic'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Media Analytics</span>
                </div>
              }
              key="mediaAnalytic"
            >
              <div className="tab-content">
                {activeTab === 'mediaAnalytic' && (
                  <MediaAnalytic history={history} />
                )}
              </div>
            </TabPane>
            <TabPane
              tab={
                <>
                  <i className="feather-map" /> Analytic
                </>
              }
              key="analytic"
            >
              <div className="tab-content">
                {activeTab === 'analytic' && <Analytics />}
              </div>
            </TabPane>
            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                >
                  <i className="feather-settings" />

                  <span>CONFIGURATION</span>
                </div>
              }
              key="configuration"
            >
              <div className="tab-content">
                {activeTab === 'configuration' && <Configuration />}
              </div>
            </TabPane>
          </Tabs>
        ) : userData.role === 'user' || userData.role === 'admin' ? (
          <Tabs activeKey={activeTab} onTabClick={handleChangeTab}>
            {grantAccess && validateMenu(grantAccess.media) && (
              <TabPane
                onMouseOver={() => setHoverTab('media')}
                onMouseLeave={() => setHoverTab('')}
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                  >
                    <GalleryIcon
                      color={
                        activeTab === 'media' || hoverTab === 'media'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Media</span>
                    {/* <DownOutlined /> */}
                  </div>
                  // </Dropdown>
                }
                key={activeTab === 'mediaCategory' ? 'mediaCategory' : 'media'}
              >
                <div className="tab-content">
                  {activeTab === 'media' && <MediaLibrary history={history} />}
                  {activeTab === 'mediaCategory' && <MediaCategories />}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.mediaanalytic) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('mediaAnalytic')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <BoxIcon
                      color={
                        activeTab === 'mediaAnalytic' ||
                        hoverTab === 'mediaAnalytic'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Media Analytics</span>
                  </div>
                }
                key="mediaAnalytic"
              >
                <div className="tab-content">
                  {activeTab === 'mediaAnalytic' && (
                    <MediaAnalytic history={history} />
                  )}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.poi) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('poi')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <BoxIcon
                      color={
                        activeTab === 'poi' || hoverTab === 'poi'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Tenants</span>
                  </div>
                }
                key="poi"
              >
                <div className="tab-content">
                  {activeTab === 'poi' && console.log('poi showing')}
                  {activeTab === 'poi' && <Pois history={history} />}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.event) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('event')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <BoxIcon
                      color={
                        activeTab === 'event' || hoverTab === 'event'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Events</span>
                  </div>
                }
                key="event"
              >
                <div className="tab-content">
                  {activeTab === 'event' && <Events history={history} />}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.deal) && (
            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('deal')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'deal' || hoverTab === 'deal'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Deals</span>
                </div>
              }
              key="deal"
            >
              <div className="tab-content">
                {activeTab === 'deal' && <Deals history={history} />}
              </div>
            </TabPane>
          )}

            {grantAccess && validateMenu(grantAccess.roommanagement) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('bookingManagement')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <RoomManagementIcon
                      color={
                        activeTab === 'bookingManagement' ||
                        hoverTab === 'bookingManagement'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Booking Management</span>
                  </div>
                }
                key="bookingManagement"
              >
                <BookingManagement history={history} />
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.information) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('information')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <InfoIcon
                      color={
                        activeTab === 'information' ||
                        hoverTab === 'information'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Information</span>
                  </div>
                }
                key={
                  activeTab === 'informationCategory'
                    ? 'informationCategory'
                    : 'information'
                }
              >
                <div className="tab-content">
                  {activeTab === 'information' && (
                    <Information history={history} />
                  )}
                  {activeTab === 'informationCategory' && (
                    <InformationCategories />
                  )}
                </div>
              </TabPane>
            )}

            {/* {grantAccess && validateMenu(grantAccess.form) && (
            <TabPane
              tab={
                <div
                  onClick={(e) => e.preventDefault()}
                  className="siteinfo-tab"
                  onMouseOver={() => setHoverTab('formMangement')}
                  onMouseLeave={() => setHoverTab('')}
                >
                  <BoxIcon
                    color={
                      activeTab === 'formMangement' ||
                      hoverTab === 'formMangement'
                        ? '#0851B5'
                        : '#9E9E9E'
                    }
                    size={18}
                  />
                  <span>Form Management</span>
                </div>
              }
              key="formManagement"
            >
              <div className="tab-content">
                {activeTab === 'formManagement' && (
                  <FormFlow
                    siteId={siteId}
                    url={url}
                    access={grantAccess.form}
                  />
                )}
              </div>
            </TabPane>
          )} */}

            {grantAccess && validateMenu(grantAccess.screen) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                    onMouseOver={() => setHoverTab('screen')}
                    onMouseLeave={() => setHoverTab('')}
                  >
                    <MessageIcon
                      color={
                        activeTab === 'screen' || hoverTab === 'screen'
                          ? '#0851B5'
                          : '#9E9E9E'
                      }
                      size={18}
                    />
                    <span>Screen</span>
                  </div>
                }
                key={'screens'}
              >
                <div className="tab-content">
                  {activeTab === 'screens' && <Screens history={history} />}
                  {activeTab === 'screenSetting' && (
                    <ScreenSettings handleChangeTab={handleChangeTab} />
                  )}
                  {activeTab === 'configVariable' && (
                    <ConfigVariable handleChangeTab={handleChangeTab} />
                  )}
                  {activeTab === 'screenConfiguration' && (
                    <ScreenConfiguration handleChangeTab={handleChangeTab} />
                  )}
                  {activeTab === 'fileManagement' && (
                    <FileManagement handleChangeTab={handleChangeTab} />
                  )}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.map) && (
              <TabPane
                tab={
                  <>
                    <i className="feather-map" /> Wayfinding
                  </>
                }
                key="wayfinding"
              >
                <div className="tab-content">
                  {activeTab === 'wayfinding' && <Maps />}
                </div>
              </TabPane>
            )}
            {grantAccess && validateMenu(grantAccess.analytic) && (
              <TabPane
                tab={
                  <>
                    <i className="feather-map" /> Analytic
                  </>
                }
                key="analytic"
              >
                <div className="tab-content">
                  {activeTab === 'analytic' && <Analytics />}
                </div>
              </TabPane>
            )}

            {grantAccess && validateMenu(grantAccess.config) && (
              <TabPane
                tab={
                  <div
                    onClick={(e) => e.preventDefault()}
                    className="siteinfo-tab"
                  >
                    <i className="feather-settings" />

                    <span>CONFIGURATION</span>
                  </div>
                }
                key="configuration"
              >
                <div className="tab-content">
                  {activeTab === 'configuration' && <Configuration />}
                </div>
              </TabPane>
            )}
          </Tabs>
        ) : null}

        {/* <div className="bottom-nav">
        <button
          onClick={handleBack}
          className="button-primary siteinfo-back-button"
        >
          Back
        </button>
      </div> */}
      </div>
    </>
  );
}

export default SiteInfo;
